import React, { useEffect, useState } from "react";
import "./navbar-Style.css";
import Logo from "../../img/DkLogo-Branco.svg";
import WhatsAppIcon from "../../img/icons/Whats.svg";

/* Links padrão */
const defaultLinks = [
  { href: "home", label: "Principal" },
  { href: "sobre", label: "Sobre" },
  { href: "localizacao", label: "Localização" },
  { href: "planos", label: "Planos" },
  { href: "contato", label: "Contato" },
];

/* WhatsApp */
const whatsappNumber = "5511970874083";
const mensagem = encodeURIComponent("Olá! vim pelo site do DK Coworking.");
const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${mensagem}`;

export default function NavBar({ links = defaultLinks }) {
  const [scrolled, setScrolled] = useState(false);

  /* Detecta scroll */
  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  /* Scroll suave até a seção */
  const handleScroll = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  return (
    <nav className={`navbar ${scrolled ? "navbar--shrink" : ""}`}>
      {/* LOGO */}
      <div className="navbar__left">
        <a
          href="#home"
          onClick={(e) => {
            e.preventDefault();
            handleScroll("home");
          }}
          className="navbar__logo"
        >
          <img src={Logo} alt="DK Coworking" />
        </a>
      </div>

      {/* LINKS + WHATSAPP */}
      <div className="navbar__right">
        <ul
          className="navbar__list"
          role="menubar"
          aria-label="Navegação principal"
        >
          {links.map((link, idx) => (
            <li key={idx} className="navbar__item" role="none">
              <a
                href={`#${link.href}`}
                className="navbar__link"
                role="menuitem"
                onClick={(e) => {
                  e.preventDefault();
                  handleScroll(link.href);
                }}
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        {/* WhatsApp */}
        <a
          href={whatsappUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="navbar__whatsapp"
        >
          <img src={WhatsAppIcon} alt="Fale conosco no WhatsApp" />
        </a>
      </div>
    </nav>
  );
}
